import { render } from "./ProductReportPage.vue?vue&type=template&id=b887bf82&scoped=true&ts=true"
import script from "./ProductReportPage.vue?vue&type=script&lang=ts"
export * from "./ProductReportPage.vue?vue&type=script&lang=ts"

import "./ProductReportPage.vue?vue&type=style&index=0&id=b887bf82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b887bf82"]])

export default __exports__